(function () {
    'use strict';

    angular
        .module('bcmModule')
        .directive('bcmResponsibility', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        var directiveScope = _.clone(boxTmplScope);

        directiveScope.onSelect = '&';
        directiveScope.onRemove = '&';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$scope', '$controller',
                function ($scope, $controller) {

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/BCM/BCMResponsibility/bcmResponsibility.[Template].tpl.html';

                    // Permissions default values
                    $scope.boxFeatureRole = $scope.boxFeatureRole || 'BCMManagement';
                    $scope.boxPermissionKey = $scope.boxPermissionKey || 'BIAProfile';

                    $controller('BoxTmplController', { $scope: $scope });

                    // Is Impact Defined?
                    $scope.isImpactDefined = function (impact) {
                        return !_.isUndefined(impact);
                    };

                }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();
